function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var SvgRevisionSolicitud = function SvgRevisionSolicitud(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFCACC"
    },
    cx: 100,
    cy: 100,
    r: 100
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DADADA"
    },
    d: "M35,72.595v64.803c0,2.754,2.248,5.002,5.002,5.002h119.996c2.754,0,5.002-2.248,5.002-5.002V72.595 c0,0-31.04,10.003-65,10.003S35,72.595,35,72.595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6D6D6D"
    },
    d: "M159.998,57.6H40.002C37.248,57.6,35,59.848,35,62.602v9.993c0,0,31.04,10.003,65,10.003 s65-10.003,65-10.003v-9.993C165,59.848,162.752,57.6,159.998,57.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.504,
    y: 91.302,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.998,
    height: 35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.995,
    y: 90.1,
    style: {
      fill: "#494949"
    },
    width: 70.002,
    height: 7.503
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.995,
    y: 105.096,
    style: {
      fill: "#494949"
    },
    width: 50.007,
    height: 7.502
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 120.1,
    style: {
      fill: "#494949"
    },
    width: 24.997,
    height: 7.502
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.995,
    y: 120.1,
    style: {
      fill: "#494949"
    },
    width: 25.007,
    height: 7.502
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#242424"
    },
    d: "M170.381,104.735c-11.94-15.84-34.445-18.996-50.286-7.068 c-15.827,11.938-19.004,34.445-7.057,50.285c11.918,15.835,34.441,18.999,50.277,7.065 C179.152,143.085,182.306,120.562,170.381,104.735z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M163.893,109.626c-9.237-12.266-26.646-14.705-38.915-5.468c-12.243,9.23-14.693,26.652-5.455,38.906 c9.229,12.252,26.65,14.703,38.906,5.464C170.683,139.292,173.131,121.876,163.893,109.626z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#242424"
    },
    points: "173.704,162.174 167.326,166.972 155.321,151.044 161.69,146.235 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#242424"
    },
    points: "200,192.899 190.388,200 160.868,161.711 170.491,154.594 "
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRevisionSolicitud, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/revisionSolicitud.add32e4c.svg";
export { ForwardRef as ReactComponent };